function injectStyle (ssrContext) {
  require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-748b2328\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CharismaItems.vue")
}
var normalizeComponent = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CharismaItems.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CharismaItems.vue"
/* template */
import __vue_template__ from "!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-748b2328\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CharismaItems.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/Views/Reports/Versions/2/CharismaItems.vue
// module id = nQ+w
// module chunks = 1